import MenuSelectorSFC from "./MenuSelector.vue";
export const MenuSelector = MenuSelectorSFC;
